import * as React from "react";
import { MapPin, Phone, Mail, Clock, Navigation } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function ContactInformation() {
  const address = "52 Sparks Street, Ottawa, Canada";
  const mapQuery = encodeURIComponent(address);
  const mapEmbedUrl = `https://maps.google.com/maps?q=${mapQuery}&t=&z=14&ie=UTF8&iwloc=&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${mapQuery}`;
  const contactDetails = [{
    icon: MapPin,
    title: "Headquarters",
    value: address
  }, {
    icon: Phone,
    title: "Direct Line",
    value: "+1 343 882 4483"
  }, {
    icon: Mail,
    title: "Secure Email",
    value: "contact@thelondonblockchaincentre.com"
  }, {
    icon: Clock,
    title: "Response Time",
    value: "Current Average: 4 Hours"
  }];
  return <section data-section-id="156254" id="global-operations" className="dark bg-background text-foreground relative w-full min-h-[600px] md:min-h-[700px] flex items-center py-16 overflow-hidden">
      <div className="absolute inset-0 z-0 bg-muted">
        <iframe title="Forensic Operations Center" src={mapEmbedUrl} className="w-full h-full border-0 grayscale contrast-125 opacity-30 mix-blend-luminosity pointer-events-none" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        <div className="three-d-animation-bg absolute inset-0 pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/60 to-transparent pointer-events-none" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex justify-start">
        <Card className="w-full max-w-md shadow-xl shadow-primary/5 border-primary/20 bg-card/40 backdrop-blur-xl">
          <CardHeader className="pb-4">
            <div className="blockchain-animation-header w-full h-16 mb-4 bg-primary/5 rounded-lg border border-primary/10 flex items-center justify-center overflow-hidden" />
            <CardTitle className="text-2xl md:text-3xl font-bold tracking-tight font-sans text-foreground">
              Global Operations
            </CardTitle>
            <CardDescription className="text-base text-muted-foreground">
              Secure headquarters for international blockchain forensics and asset recovery investigations.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-6">
            <div className="grid gap-4">
              {contactDetails.map((detail, i) => {
              return <div data-index={i} key={i} className="flex items-start gap-4">
                    <div className="bg-primary/10 p-2 rounded-sm shrink-0 mt-0.5 border border-primary/20">
                      <div className="size-5 icon-3d-placeholder bg-primary/30 rounded-full animate-pulse" />
                    </div>
                    <div className="grid gap-1">
                      <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground/70 font-sans">
                        {detail.title}
                      </p>
                      <p className="text-sm font-medium leading-snug font-mono text-primary">
                        {detail.value}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </CardContent>
          <CardFooter className="pt-2">
            <Button asChild className="w-full group bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_20px_hsla(180,100%,50%,0.2)]" size="lg">
              <Link to={directionsUrl} newTab>
                <Navigation className="mr-2 size-4 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                Establish Secure Route
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}